class ProductGridSorter {
  constructor() {
    this.priceSortState = 'none';
    this.gbSortState = 'none';
    this.init();
  }

  init() {
    const priceSortBtn = document.querySelector('[data-price-sorting]');
    const gbSortBtn = document.querySelector('[data-gb-sorting]');

    if (priceSortBtn) {
      priceSortBtn.addEventListener('click', () => this.handlePriceSort());
    }

    if (gbSortBtn) {
      gbSortBtn.addEventListener('click', () => this.handleGbSort());
    }
  }

  handlePriceSort() {
    const productGrid = document.getElementById('product-grid');
    if (!productGrid) return;
    if (this.priceSortState === 'none' || this.priceSortState === 'desc') {
      this.priceSortState = 'asc';
      this.sortByPrice('asc');
    } else {
      this.priceSortState = 'desc';
      this.sortByPrice('desc');
    }
    this.gbSortState = 'none';
    this.updateSortIndicators();
  }

  handleGbSort() {
    const productGrid = document.getElementById('product-grid');
    if (!productGrid) return;
    if (this.gbSortState === 'none' || this.gbSortState === 'desc') {
      this.gbSortState = 'asc';
      this.sortByGb('asc');
    } else {
      this.gbSortState = 'desc';
      this.sortByGb('desc');
    }
    this.priceSortState = 'none';
    this.updateSortIndicators();
  }

  sortByPrice(direction) {
    const productGrid = document.getElementById('product-grid');
    const products = Array.from(productGrid.querySelectorAll('li'));

    products.sort((a, b) => {
      const priceA = this.getProductPrice(a);
      const priceB = this.getProductPrice(b);

      if (direction === 'asc') {
        return priceA - priceB;
      } else {
        return priceB - priceA;
      }
    });
    products.forEach(product => {
      productGrid.appendChild(product);
    });
  }

  sortByGb(direction) {
    const productGrid = document.getElementById('product-grid');
    const products = Array.from(productGrid.querySelectorAll('li'));

    products.sort((a, b) => {
      const gbA = this.getProductGb(a);
      const gbB = this.getProductGb(b);

      if (direction === 'asc') {
        return gbA - gbB;
      } else {
        return gbB - gbA;
      }
    });
    products.forEach(product => {
      productGrid.appendChild(product);
    });
  }

  getProductPrice(productElement) {
    const priceSpan = productElement.querySelector('[data-price-display]');
    if (!priceSpan) return 0;
    const priceText = priceSpan.textContent.trim();
    const numericMatch = priceText.match(/[\d,]+\.?\d*/);
    return numericMatch ? parseFloat(numericMatch[0].replace(/,/g, '')) : 0;
  }

  getProductGb(productElement) {
    const variantSelect = productElement.querySelector('[data-variant-select]');
    if (!variantSelect) return 0;

    const selectedOption = variantSelect.options[variantSelect.selectedIndex];
    if (!selectedOption) return 0;

    const variantTitle = selectedOption.textContent.trim();
    const gbMatch = variantTitle.match(/(\d+(?:\.\d+)?)\s*(GB|TB)/i);
    if (gbMatch) {
      let value = parseFloat(gbMatch[1]);
      const unit = gbMatch[2].toUpperCase();
      if (unit === 'TB') {
        value *= 1024;
      }

      return value;
    }

    return 0;
  }

  updateSortIndicators() {
    const priceSortBtn = document.querySelector('[data-price-sorting]');
    const gbSortBtn = document.querySelector('[data-gb-sorting]');

    if (priceSortBtn) {
      priceSortBtn.classList.remove('sort-asc', 'sort-desc');
      if (this.priceSortState === 'asc') {
        priceSortBtn.classList.add('sort-asc');
      } else if (this.priceSortState === 'desc') {
        priceSortBtn.classList.add('sort-desc');
      }
    }

    if (gbSortBtn) {
      gbSortBtn.classList.remove('sort-asc', 'sort-desc');
      if (this.gbSortState === 'asc') {
        gbSortBtn.classList.add('sort-asc');
      } else if (this.gbSortState === 'desc') {
        gbSortBtn.classList.add('sort-desc');
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new ProductGridSorter();
});